<div>
  <div class="container-fluid">
    <!-- Page Header -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="d-flex align-items-center gap-3">
        <h1 class="h2 mb-1 fw-bold">Unassigned Tickets</h1>
        <span class="badge bg-warning fs-6" *ngIf="unassignedCount > 0">
          {{ unassignedCount }}
        </span>
      </div>
    </div>

    <!-- Error Alert -->
    <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      {{ errorMessage }}
      <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''"></button>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 text-muted">Loading unassigned tickets...</p>
    </div>

    <!-- Tickets Table -->
    <div *ngIf="!loading" class="card overflow-hidden">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table data-table table-hover mb-0">
            <thead>
              <tr>
                <th>Ticket #</th>
                <th>Subject</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Contact Email</th>
                <th>Contact Phone</th>
                <th>Created Date</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <!-- Empty State -->
              <tr *ngIf="tickets.length === 0">
                <td colspan="8" class="text-center py-5 text-muted">
                  <i class="bi bi-ticket-perforated fs-1 d-block mb-2"></i>
                  No unassigned tickets
                </td>
              </tr>
              <!-- Ticket Rows -->
              <tr *ngFor="let ticket of tickets">
                <td>
                  <span class="fw-medium">{{ ticket.ticketNumber }}</span>
                </td>
                <td>{{ ticket.subject }}</td>
                <td>
                  <span class="badge" [ngClass]="getStatusBadgeClass(ticket.status)">
                    {{ ticket.status }}
                  </span>
                </td>
                <td>
                  <span class="badge" [ngClass]="getPriorityBadgeClass(ticket.priority)">
                    {{ ticket.priority }}
                  </span>
                </td>
                <td>
                  <span *ngIf="ticket.contactEmail">{{ ticket.contactEmail }}</span>
                  <span *ngIf="!ticket.contactEmail" class="text-muted">-</span>
                </td>
                <td>
                  <span *ngIf="ticket.contactPhone">{{ ticket.contactPhone | phoneFormat }}</span>
                  <span *ngIf="!ticket.contactPhone" class="text-muted">-</span>
                </td>
                <td>{{ formatDate(ticket.createdAt) }}</td>
                <td class="text-end">
                  <button
                    class="btn btn-sm btn-outline-primary"
                    (click)="openAssignModal(ticket)"
                    title="Assign to Organization"
                  >
                    <i class="bi bi-person-plus me-1"></i>
                    Assign
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination Footer -->
      <div class="card-footer d-flex justify-content-between align-items-center" *ngIf="totalTickets > 0">
        <div class="text-muted">
          Page {{ currentPage }} of {{ totalPages }}
        </div>
        <nav *ngIf="totalPages > 1">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <button class="page-link" (click)="onPageChange(currentPage - 1)">
                <i class="bi bi-chevron-left"></i> Prev
              </button>
            </li>
            <li class="page-item" [class.disabled]="currentPage === totalPages">
              <button class="page-link" (click)="onPageChange(currentPage + 1)">
                Next <i class="bi bi-chevron-right"></i>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Assign Ticket Modal -->
<app-assign-ticket-modal
  *ngIf="showAssignModal && selectedTicket"
  [ticket]="selectedTicket"
  (assigned)="onTicketAssigned()"
  (closed)="onModalClosed()"
></app-assign-ticket-modal>
